import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { Trans, useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";

const UserPlan = () => {
  const { t } = useTranslation();
  const userPlanItem = [
    {
      title:
        "Level 1: Email and mobile verification and at least one bank card",
      body: [
        "Ability to deposit unlimited currency password",
        "Possibility of exchanging in Ramzarz to Ramzarz and Ramzarz to Rials markets indefinitely",
        "Rial deposit ceiling: 1 million Tomans in the last 24 hours",
        "Ramzarz harvest ceiling: equivalent to 40 million Tomans in the last 24 hours",
        "Rial withdrawal ceiling: equivalent to 10 million Tomans in the last 24 hours",
        "The total withdrawal ceiling of Ramzarz and Rials in the last 30 days is 150 million Tomans",
      ],
    },
    {
      title:
        "Level 2: Email and mobile verification and at least one bank card and national card (selfie)",
      body: [
        "Ability to deposit unlimited currency password",
        "Possibility of exchanging in Ramzarz to Ramzarz and Ramzarz to Rials markets indefinitely",
        "Rial deposit ceiling: 10 million Tomans in the last 24 hours",
        "Ramzarz harvest ceiling: equivalent to 80 million Tomans in the last 24 hours",
        "Rial withdrawal ceiling: equivalent to 40 million Tomans in the last 24 hours",
        "The total withdrawal ceiling of Ramzarz and Rials in the last 30 days is 500 million Tomans",
      ],
    },
    {
      title:
        "Level 3: Email and mobile verification and at least one bank card, national card (selfie), landline number, selfie image of national card and bank card with specified text, home address",
      body: [
        "Ability to deposit unlimited currency password",
        "Possibility of exchanging in Ramzarz to Ramzarz and Ramzarz to Rials markets indefinitely",
        "Rial deposit ceiling: 60 million Tomans in the last 24 hours",
        "Ramzarz harvest ceiling: equivalent to 120 million Tomans in the last 24 hours",
        "Rial withdrawal ceiling: equivalent to 80 million Tomans in the last 24 hours",
        "The total withdrawal ceiling of Ramzarz and Rials in the last 30 days is 800 million Tomans",
      ],
    },
    {
      title:
        "Level 4: To upgrade your account to this level, please send your request to the support department via ticket.",
      body: [
        "Ability to deposit unlimited currency password",
        "Possibility of exchanging in Ramzarz to Ramzarz and Ramzarz to Rials markets indefinitely",
        "Rial deposit ceiling: 300 million Tomans in the last 24 hours",
        "Ramzarz harvest ceiling: equivalent to 400 million Tomans in the last 24 hours",
        "Rial withdrawal ceiling: equivalent to 200 million Tomans in the last 24 hours",
        "The total withdrawal ceiling of Ramzarz and Rials in the last 30 days is 1.5 billion Tomans",
      ],
    },
  ];
  return (
    <>
      <StaticHeaderInfo>
        <div className="title-style mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("User Levels and Authentication in coinnik Market")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Row>
          <Col xl="12">
            <Card className="shadow mt-lg-3  mt-n5 mt-md-0">
              <Row className="py-3  flex-row-reverse ">
                <Col xs="12" className="list bullet-point user-plan-list-style">
                  <CardBody>
                    <CardTitle className="mb-5">
                      <span className="title-bordre-bottom ">
                        {t("Authentication levels")}
                      </span>
                    </CardTitle>
                    {userPlanItem.map((item) => (
                      <ul className="pb-5">
                        <li>{t(item.title)}</li>
                        {item.body.map((item) => (
                          <li className=" text-secondary-two-light py-1">
                            <Trans
                              i18nKey={item}
                              components={[
                                <span className="text-danger-light fw-medium" />,
                              ]}
                            />
                          </li>
                        ))}
                      </ul>
                    ))}
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default UserPlan;
